if (!customElements.get('header-logo-motion')) {
  customElements.define('header-logo-motion', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      // Embedded WebKit browsers can require fullscreen even with playsinline.
      // Check the host's policy before assigning a source or calling play().
      const isWebKitVideo = 'webkitSupportsPresentationMode' in this.video ||
        'webkitDisplayingFullscreen' in this.video;
      if (isWebKitVideo && !matchMedia('(-webkit-video-playable-inline)').matches) {
        this.classList.remove('is-ready');
        this.classList.add('is-error');
        return;
      }
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      // The poster supplies the first paint. Start decorative video only after
      // critical page resources have finished, rather than competing with them.
      this.pageLoaded = document.readyState === 'complete';
      this.paintReady = !this.hasAttribute('data-wait-product-paint');
      this.onLoad = () => { this.pageLoaded = true; this.update(); };
      this.update = () => {
        if (!this.pageLoaded || !this.paintReady || this.motion.matches || document.hidden || !this.visible) {
          this.video.pause();
          if (this.motion.matches) this.classList.remove('is-ready');
          return;
        }
        if (!this.video.src) this.video.src = this.video.dataset.src;
        this.video.muted = true;
        this.video.play().catch(() => this.classList.remove('is-ready'));
      };
      this.onPlaying = () => { this.classList.remove('is-error'); this.classList.add('is-ready'); };
      this.onError = () => { this.classList.remove('is-ready'); this.classList.add('is-error'); };
      this.video.addEventListener('playing', this.onPlaying);
      this.video.addEventListener('error', this.onError);
      this.motion.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      window.addEventListener('load', this.onLoad, { once: true });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      if (!this.paintReady) {
        if (window.PerformanceObserver?.supportedEntryTypes?.includes('paint')) {
          this.paintObserver = new PerformanceObserver(list => {
            if (!this.isConnected || !list.getEntries().some(entry => entry.name === 'first-contentful-paint')) return;
            this.paintReady = true;
            this.paintObserver.disconnect();
            this.update();
          });
          this.paintObserver.observe({ type: 'paint', buffered: true });
        } else {
          this.paintFallback = () => requestAnimationFrame(() => requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.paintReady = true;
            this.update();
          }));
          if (this.pageLoaded) this.paintFallback();
          else window.addEventListener('load', this.paintFallback, { once: true });
        }
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.paintObserver?.disconnect();
      if (this.paintFallback) window.removeEventListener('load', this.paintFallback);
      this.motion?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
      window.removeEventListener('load', this.onLoad);
      this.video?.pause();
      this.video?.removeEventListener('playing', this.onPlaying);
      this.video?.removeEventListener('error', this.onError);
    }
  });
}
